<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="30%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="40%" class="titleSpan tableTitle">项 目 档 案 存 档 登 记 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第二行(2表) -->
      <tr style="height:50px">
        <td width="15%" class="titleSpan">企业名称</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <tr style="height:600px">
        <td colspan="2" class="contentSpan">
          <div
            style="min-height:400px;text-align:left;box-sizing:border-box;padding:10px;"
          >{{printData.company_name}}</div>
        </td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td width="50%" colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>项目负责人签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
          </div>
          <div style="text-align:right;box-sizing:border-box;padding:10px;padding-bottom:20px">年 月 日</div>
        </td>
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>档案管理人员签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
          </div>
          <div style="text-align:right;box-sizing:border-box;padding:10px;padding-bottom:20px">年 月 日</div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>